export const thousandsSeparator = (s) => s.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
export const startsWithZeroAndLengthIsGreaterThanOne = (s) => s.startsWith("0") && s.length > 1;
export const removePeriods = (s) => s.replace(/[.]/g, "");
export const removeNonDigits = (n) => n.replace(/\D/g, "");
export const containsPeriod = (s) => s.includes(".");
export const truncateString = (input) => {
    if (input.length <= 300)
        return input;
    const firstPart = input.slice(0, 200);
    const lastPart = input.slice(-50);
    return `${firstPart}... ...${lastPart}`;
};
//# sourceMappingURL=input-parse.js.map